import React from "react";

const LOGO_URL = "/ard-logo.png";

// Official ARD Performance Midsouth badge.
export function Logo({ className = "", size = 44 }) {
  return (
    <div className={`flex items-center ${className}`} data-testid="ard-logo">
      <img
        src={LOGO_URL}
        alt="ARD Performance Midsouth"
        style={{ height: size, width: size }}
        className="object-contain"
      />
    </div>
  );
}
